var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('faf-card',{attrs:{"name":"my-jobs","title":"Hetkel töös"}},[_c('faf-my-jobs',{ref:"jobs"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }